import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import AboutUs from '@/components/pages/AboutUs'
import OurProducts from '@/components/pages/OurProducts'
import ProductDetails from '@/components/pages/ProductDetails'
import OurServices from '@/components/pages/OurServices'
import ServiceDetails from '@/components/pages/ServiceDetails'
import ContactUs from '@/components/pages/ContactUs'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
}, {
    path: '/a-propos-de-nous',
    name: 'AboutUs',
    component: AboutUs
}, {
    path: '/nos-produits',
    name: 'OurProducts',
    component: OurProducts
}, {
    path: '/produit/:productSlug',
    name: 'ProductDetails',
    component: ProductDetails
}, {
    path: '/nos-services',
    name: 'OurServices',
    component: OurServices
}, {
    path: '/service/:serviceSlug',
    name: 'ServiceDetails',
    component: ServiceDetails
}, {
    path: '/contactez-nous',
    name: 'ContactUs',
    component: ContactUs
}]

const router = new Router({
    history: true,
    mode: 'history',
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return {
                selector: to.hash
            }
        } else {
            return { x: 0, y: 0 }
        }
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js